/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import clsx from 'clsx';
import { useAppSelector } from '../../../../services/redux/app/Store';
import { KTSVG } from '../../../helpers';
import { AsideMenuItem } from './AsideMenuItem';
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub';

export function AsideMenuMain() {
  const { offerEnabled } = useAppSelector((state) => state.auth);
  return (
    <>
      <AsideMenuItem to="/dashboard" icon="/media/sidebar/home.svg" title="Anasayfa" fontIcon="bi-app-indicator" />
      <AsideMenuItemWithSub to="/products" title="Ürünlerim" fontIcon="bi-archive" icon="/media/sidebar/product.svg">
        <AsideMenuItem to="/products/my-products" title="Tümü" hasBullet={true} />
        <AsideMenuItem to="/products/product-operations" title="Ürün İşlemleri" hasBullet={true} />
        <AsideMenuItem to="/products/questions" title="Ürün Soruları" hasBullet={true} />
        <AsideMenuItem to="/products/evaluation" title="Ürün Değerlendirmeleri" hasBullet={true} />
        <AsideMenuItem to="/products/add-products/bulk-options" title="Marka Ekleme Talepleri" hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItem to="/inventory" title="Envanter" fontIcon="bi-archive" icon="/media/sidebar/inventories.svg" />
      <AsideMenuItemWithSub to="/orders" title="Sipariş" fontIcon="bi-archive" icon="/media/sidebar/orders.svg">
        <AsideMenuItem to="/orders/orders-management" title="Siparişler" hasBullet={true} />
        <AsideMenuItem to="/orders/cancelled" title="İptaller" hasBullet={true} />
        <AsideMenuItem to="/orders/refund" title="İadeler" hasBullet={true} />
        <AsideMenuItem to="/orders/cargo" title="Kargo İşlemleri" hasBullet={true} />
        <AsideMenuItem to="/orders/questions" title="Sipariş Soruları" hasBullet={true} />
        <AsideMenuItem to="/orders/order-evaluation" title="Sipariş Değerlendirmeleri" hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub to="#" title="Finans" fontIcon="bi-archive" icon="/media/sidebar/finance.svg">
        {/* <AsideMenuItem to="/finance" title="Finans Sayfam" hasBullet={true} /> */}
        <AsideMenuItem to="/finance/vesting" title="Hak Ediş" hasBullet={true} />
        <AsideMenuItem to="/finance/payment" title="Ödemeler" hasBullet={true} />
        {/* <AsideMenuItem to="/finance/records" title="Kayıtlar" hasBullet={true} /> */}
        <AsideMenuItem to="/finance/invoices" title="Fatura İşlemleri" hasBullet={true} />
        <AsideMenuItem to="/finance/invoice-requests" title="Fatura Talepleri" hasBullet={true} />
        <AsideMenuItem to="/finance/current" title="Cari Hesap Ekstresi" hasBullet={true} />
        <AsideMenuItem to="/finance/current" title="Dönem Mutabakatlarım" hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub to="#" title="Kampanya" fontIcon="bi-archive" icon="/media/sidebar/campaign.svg">
        <AsideMenuItem to="/campaigns/list" title="Kampanyalar" hasBullet={true} />
        <AsideMenuItem to="/campaigns/create" title="Kampanya Oluştur" hasBullet={true} />
        <AsideMenuItem to="/campaigns/coupons" title="Kuponlarım" hasBullet={true} />
        {offerEnabled && <AsideMenuItem to="/campaigns/commission-offers" title="Komisyon Tekliflerim" hasBullet={true} />}
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub to="/reports" title="Raporlar" fontIcon="bi-app-indicator" icon="/media/sidebar/report.svg">
        <AsideMenuItem to="/reports/sales" title="Satış Raporları" hasBullet={true} />
        <AsideMenuItem to="/reports/refund" title="İade Raporları" hasBullet={true} />
        <AsideMenuItem to="/reports/cancel" title="İptal Raporları" hasBullet={true} />
        <AsideMenuItem to="/reports/delayed" title="Geciken Sipariş Raporları" hasBullet={true} />
        {/* <AsideMenuItem to="/reports/campaign-reports" title="Kampanya Raporları" hasBullet={true} />
        <AsideMenuItem to="/reports/coupon-reports" title="Kupon Raporları" hasBullet={true} /> */}
      </AsideMenuItemWithSub>

      {/* <AsideMenuItem to="/showcase" icon="/media/sidebar/mall.svg" title="Mağaza Vitrin" fontIcon="bi-app-indicator" /> */}
      <AsideMenuItem to="/support" icon="/media/sidebar/support.svg" title="Destek Talepleri" fontIcon="bi-app-indicator" />
      <div className="menu-item">
        <a href="https://bilgimerkezi.idefix.com/" target="_blank" className="menu-link without-sub">
          <span className="menu-icon">
            <KTSVG path="/media/sidebar/support.svg" className="svg-icon-2" />
          </span>
          <i className={clsx('bi fs-3', 'bi-app-indicator')}></i>
          <span className="menu-title">idefix Bilgi Merkezi</span>
        </a>
      </div>
    </>
  );
}
